import { MessageType } from 'common/dto-types/message-dto';

const MessageTypeCell = ({ value }: { value: MessageType }): JSX.Element => {
    switch (value) {
        case MessageType.Article:
            return <p>Article</p>;
        case MessageType.Promotion:
            return <p>Promotion</p>;
        default:
            return <></>;
    }
};

export default MessageTypeCell;
